/**
 * Live Support Component JavaScript
 * Canlı destek butonu için interaktif özellikler
 */

class LiveSupport {
  constructor() {
    this.button = document.querySelector('.live-support');
    this.isVisible = true;
    this.lastScrollTop = 0;
    this.init();
  }

  init() {
    if (!this.button) return;
    
    // Click olayını dinle
    this.button.addEventListener('click', this.handleClick.bind(this));
    
    // Hover animasyonları için
    this.button.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.button.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    
    // Touch olayları için
    this.button.addEventListener('touchstart', this.handleTouchStart.bind(this));
    this.button.addEventListener('touchend', this.handleTouchEnd.bind(this));
    
    // Window resize olayını dinle
    window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
    
    // Always visible ayarını kontrol et
    this.checkAlwaysVisibleSetting();
    
    // Butonun her zaman görünür olmasını sağla
    this.ensureVisibility();
  }

  checkAlwaysVisibleSetting() {
    // Shopify settings'den always_visible değerini al
    const alwaysVisibleMeta = document.querySelector('meta[name="live-support-always-visible"]');
    if (alwaysVisibleMeta && alwaysVisibleMeta.content === 'false') {
      // Scroll ile gizleme özelliğini etkinleştir
      this.handleScroll = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
  }

  ensureVisibility() {
    // Butonun her zaman görünür olmasını sağla
    if (this.button) {
      this.button.style.opacity = '1';
      this.button.style.transform = 'translateY(0)';
      this.button.style.pointerEvents = 'auto';
      this.button.style.display = 'inline-block';
      this.isVisible = true;
      
      // Responsive pozisyonlama kontrolü
      this.checkResponsivePosition();
    }
  }

  checkResponsivePosition() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    
    // Çok küçük ekranlarda pozisyonu ayarla
    if (screenWidth <= 320) {
      this.button.style.right = '12px';
      this.button.style.bottom = '12px';
    } else if (screenWidth <= 480) {
      this.button.style.right = '14px';
      this.button.style.bottom = '14px';
    } else if (screenWidth <= 768) {
      this.button.style.right = '16px';
      this.button.style.bottom = '16px';
    } else if (screenWidth <= 1024) {
      this.button.style.right = '20px';
      this.button.style.bottom = '20px';
    } else {
      this.button.style.right = '24px';
      this.button.style.bottom = '24px';
    }
    
    // Landscape modda mobil cihazlar için özel ayar
    if (screenWidth > screenHeight && screenWidth <= 768) {
      this.button.style.bottom = '8px';
    }
  }

  handleClick(e) {
    // Analytics tracking için
    if (typeof gtag !== 'undefined') {
      gtag('event', 'live_support_click', {
        'event_category': 'engagement',
        'event_label': 'live_support_button'
      });
    }
    
    // Facebook Pixel tracking
    if (typeof fbq !== 'undefined') {
      fbq('track', 'Lead');
    }
    
    // Custom event dispatch
    const event = new CustomEvent('liveSupportClick', {
      detail: { timestamp: Date.now() }
    });
    document.dispatchEvent(event);
  }

  handleMouseEnter() {
    this.button.style.transform = 'translateY(-2px) scale(1.02)';
  }

  handleMouseLeave() {
    this.button.style.transform = 'translateY(0) scale(1)';
  }

  handleTouchStart() {
    this.button.style.transform = 'scale(0.98)';
  }

  handleTouchEnd() {
    this.button.style.transform = 'scale(1)';
  }

  handleResize() {
    // Ekran boyutu değiştiğinde pozisyonu güncelle
    this.checkResponsivePosition();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDelta = scrollTop - this.lastScrollTop;
    
    // Scroll yönüne göre butonu gizle/göster
    if (scrollDelta > 10 && scrollTop > 100) {
      // Aşağı scroll - butonu gizle
      this.hide();
    } else if (scrollDelta < -10) {
      // Yukarı scroll - butonu göster
      this.show();
    }
    
    this.lastScrollTop = scrollTop;
  }

  show() {
    // Buton her zaman görünür olsun
    this.ensureVisibility();
  }

  hide() {
    // Buton gizlenmesin, her zaman görünür kalsın
    this.ensureVisibility();
  }

  showWithAnimation() {
    // Buton her zaman görünür olsun
    this.ensureVisibility();
  }

  // Buton metnini dinamik olarak değiştir
  updateText(newText) {
    if (this.button) {
      this.button.textContent = newText;
    }
  }

  // Buton URL'sini dinamik olarak değiştir
  updateUrl(newUrl) {
    if (this.button) {
      this.button.href = newUrl;
    }
  }

  // Butonu tamamen kaldır
  destroy() {
    if (this.button) {
      this.button.remove();
    }
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  }
}

// DOM yüklendiğinde başlat
document.addEventListener('DOMContentLoaded', () => {
  new LiveSupport();
});

// Eğer DOM zaten yüklüyse hemen başlat
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LiveSupport();
  });
} else {
  new LiveSupport();
} 